import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaA_Van_Center: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="213"
      height="122"
      viewBox="0 0 213 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_van_center"
          x="0"
          y="0"
          width="213"
          height="122"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_a_van_center)">
        <path
          d="M106.38 1C120.565 1.02606 135.748 2.18369 147.801 3.47754C153.82 4.12366 159.026 4.80088 162.9 5.37988C164.84 5.66975 166.422 5.9317 167.594 6.14941C168.18 6.25845 168.64 6.35205 168.976 6.42773C169.189 6.47595 169.314 6.50759 169.37 6.52246L176.528 9.20703C180.363 12.1764 186.294 17.077 192.14 22.7178C198.079 28.4494 203.643 34.6719 206.949 40.2354C209.692 58.0791 210.777 75.1355 211.149 88.0215C211.339 94.5684 211.345 100.023 211.294 103.936C211.268 105.892 211.229 107.459 211.191 108.58C211.173 109.141 211.155 109.587 211.14 109.909C211.132 110.069 211.125 110.193 211.119 110.284L211.112 110.389V110.391C211.112 110.393 211.112 110.396 211.111 110.4L211.108 110.424V110.425C211.104 110.458 211.101 110.493 211.095 110.535C211.08 110.637 211.059 110.772 211.029 110.946C210.972 111.29 210.891 111.727 210.791 112.234C210.591 113.249 210.325 114.486 210.034 115.733C209.742 116.986 209.434 118.21 209.151 119.206C209.075 119.476 209.002 119.72 208.936 119.937C208.26 119.456 207.556 119.003 206.828 118.582L206.819 118.577L206.322 118.296L206.312 118.291L204.761 117.448C172.067 100.025 133.195 98.6482 120.307 98.5049H120.303L118.053 98.4883H118.043C53.329 98.2827 27.515 106.703 16.1162 112.6L16.1133 112.602L14.6104 113.386L14.6055 113.388C10.104 115.764 6.46364 117.95 3.61133 120.229C2.83234 118.315 2.09495 115.378 1.26855 110.25C1.26283 110.158 1.25614 110.035 1.24805 109.88C1.23099 109.554 1.21056 109.105 1.18848 108.541C1.14429 107.412 1.09461 105.835 1.05762 103.867C0.983628 99.932 0.958891 94.4478 1.11719 87.8721C1.42813 74.9563 2.44714 57.8933 5.17285 40.1006C12.7067 28.5822 28.1298 15.1194 35.5537 9.15723L42.1592 6.51465C42.223 6.4985 42.3395 6.47041 42.5225 6.42969C42.8658 6.35327 43.3379 6.25824 43.9434 6.14746C45.1498 5.9267 46.7826 5.66032 48.7822 5.36621C52.7772 4.77863 58.1451 4.09231 64.3252 3.43945C75.9292 2.21364 90.2782 1.11851 103.706 1.00781L106.38 1Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
